import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import React, { useEffect, useRef, useState } from "react";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { SlideInSelection } from "slideinselection";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { BusinessDeliveryIcon, HomeDeliveryIcon } from "wbm-custom-icons";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { WBMSelectionCard } from "wbm-selection-card";
import NavigationTokens from "../../constants/navigationTokens";
import { ISlideInSelection } from "../../interfaces/ISlideInSelection";
import { AddressesService } from "../../utilities/addressesService";
import NavigationTokensService from "../../utilities/navigationTokensService";
import ScrollBarService from "../../utilities/scrollBarService";
import UpdateShoppingLocationService from "../../utilities/updateShoppingLocationService";
import Icon from "../icon/icon";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import zip from "zippo";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Button } from "wbm-inputs";
import { LoginIntent } from "../../enums/LoginIntent";
import useLoginUrl from "../../hooks/useLoginUrl";
import { setShoppingLocation } from "@wbmason/main-header-api";
import { RegistrationSettingsService } from "../../utilities/registrationSettingsService";
import { Subscription } from "rxjs";
import { IShoppingLocation } from "../../interfaces/IShoppingLocation";

export interface IInsufficientAuthAddressSelectProps {
  formattedAddress: () => React.ReactNode;
  showZipCodeSection: boolean;
  isSecondary?: boolean;
  useExternalIdentityProvider?: boolean;
  forceOpen?: boolean;
  closeCallback?: () => void;
  shoppingLocation?: IShoppingLocation;
}

function InsufficientAuthAddressSelect({
  formattedAddress,
  showZipCodeSection,
  isSecondary,
  useExternalIdentityProvider,
  forceOpen,
  closeCallback,
  shoppingLocation,
}: IInsufficientAuthAddressSelectProps) {
  useEffect(() => {
    const navTokenSub = NavigationTokensService.get([
      NavigationTokens.RegZipCode,
    ]).subscribe((navTokens) => {
      setNavTokens(navTokens);
    });

    const registrationSettings = RegistrationSettingsService.get();
    let regCookieSub: Subscription | null = null;
    if (registrationSettings) {
      setZipCode(registrationSettings.zipCode);
      setHomeOrBusinessSelection(registrationSettings.registrationType);
    } else {
      regCookieSub = AddressesService.getAddressFromRegCookie().subscribe(
        (shoppingLocationForm) => {
          setZipCode(shoppingLocationForm.zipCode);
          setHomeOrBusinessSelection(shoppingLocationForm.registrationType);
        },
      );
    }

    return () => {
      navTokenSub.unsubscribe();
      regCookieSub?.unsubscribe();
    };
  }, []);

  const [homeOrBusinessSelection, setHomeOrBusinessSelection] = useState(99);
  const [zipCode, setZipCode] = useState("");
  const SIS = useRef<ISlideInSelection>();
  const [navTokens, setNavTokens] = useState<Record<string, string>>();
  const [invalidZipFeedback, setInvalidZipFeedback] = useState("");
  const [invalidHomeOrBusinessFeedback, setInvalidHomeOrBusinessFeedback] =
    useState("");
  const [zipInputClass, setZipInputClass] = useState("form-control");
  const [showSpinner, setShowSpinner] = useState(false);
  const loginUrl = useLoginUrl(LoginIntent.ChangeCartAddress);

  useEffect(() => {
    const registrationSettings = RegistrationSettingsService.get();
    if (registrationSettings) {
      setZipCode(registrationSettings.zipCode);
      setHomeOrBusinessSelection(registrationSettings.registrationType);
    }
  }, [shoppingLocation]);

  const submitNewZipCodeInfo = () => {
    setShowSpinner(true);
    let isZipValid = false;
    let isHomeOrBusinessValid = false;

    if (zipCode === null) {
      setInvalidZipFeedback("Please enter your zip code");
      setZipInputClass("form-control is-invalid");
      setShowSpinner(false);
    } else if (zipCode.length < 5) {
      setInvalidZipFeedback("Please enter your zip code");
      setZipInputClass("form-control is-invalid");
      setShowSpinner(false);
    } else if (!zip.validate(zipCode)) {
      setInvalidZipFeedback("Please enter a valid five digit zip code");
      setZipInputClass("form-control is-invalid");
      setShowSpinner(false);
    } else {
      isZipValid = true;
      setInvalidZipFeedback("");
      setZipInputClass("form-control is-valid");
    }

    if (
      homeOrBusinessSelection === 0 ||
      homeOrBusinessSelection === 10 ||
      homeOrBusinessSelection === 20
    ) {
      isHomeOrBusinessValid = true;
      setInvalidHomeOrBusinessFeedback("");
    } else {
      setInvalidHomeOrBusinessFeedback("Please select an option");
      setShowSpinner(false);
    }

    if (isZipValid && isHomeOrBusinessValid) {
      RegistrationSettingsService.set({
        zipCode,
        registrationType: homeOrBusinessSelection,
      });
      setZipInputClass("form-control");

      AddressesService.getShoppingLocationByZipCode(
        zipCode,
        homeOrBusinessSelection.toString(),
      ).subscribe(
        (response) => {
          // returns 500 is shiptoselection is false
          setShoppingLocation(response);
          UpdateShoppingLocationService.emitShoppingLocationChangedEvent(
            response,
          );

          reloadCurrentPage();
        },
        (error) => {
          setInvalidZipFeedback("Please enter a valid zip code");
          setZipInputClass("form-control is-invalid");
          setShowSpinner(false);
        },
      );
    }
  };

  /* const goToRegZipCode = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    if (navTokens) {
      window.location.href = navTokens[NavigationTokens.RegZipCode];
    }
  }; */

  const onZipValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setZipCode(zip.parse(val));
  };

  const reloadCurrentPage = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  return (
    <>
      {
        <div className="delivery-location-container">
          <SlideInSelection
            closeCallback={closeCallback}
            forceOpen={forceOpen}
            button={formattedAddress()}
            header={
              <b className="delivery-location-header">Delivery Location</b>
            }
            ref={SIS}
            containerId="body"
            isSecondary={isSecondary}
            onInsufficientAuthAddressSelect={true}
            appendRemoveContainerWidth={(isOpen: boolean) => {
              if (!isSecondary) {
                ScrollBarService.applyModalOpen(
                  isOpen,
                  "auth address select",
                  true,
                );
              }
            }}
          >
            <div className="delivery-location-body">
              <div>
                <span className="delivery-location-alert">
                  <ErrorOutlineIcon />
                  <span className="delivery-location-alert-text">
                    Delivery options, speeds and product availability may vary
                    for different locations.
                  </span>
                </span>
              </div>
              <div className="address-redirect-btn">
                {loginUrl && (
                  <a href={loginUrl}>
                    <Button
                      role="button"
                      type="button"
                      className="btn-lg btn-primary"
                    >
                      SIGN IN TO SEE YOUR ADDRESSES
                    </Button>
                  </a>
                )}
              </div>
              {showZipCodeSection && (
                <React.Fragment>
                  <div className="enter-zip-label">
                    <span>Or Enter a U.S. Zip Code</span>
                  </div>
                  <div className="enter-zip-input">
                    <Icon className="align-middle">location_on</Icon>
                    <input
                      id="zipcode"
                      className={zipInputClass}
                      required={true}
                      placeholder="Your Zip Code"
                      onChange={onZipValueChange}
                      aria-label="Your Zip Code"
                      value={zipCode}
                      maxLength={5}
                      pattern="[0-9]*"
                      onFocus={() => {
                        if (zipCode.length === 5) {
                          setZipCode("");
                          setHomeOrBusinessSelection(99);
                        }
                      }}
                    />
                    <div className="text-danger">{invalidZipFeedback}</div>
                  </div>
                  <div className="home-or-biz-selection">
                    <div className="shopping-for-label">I am shopping for</div>
                    <WBMSelectionCard
                      id={"home-or-biz-selection-home"}
                      selected={homeOrBusinessSelection === 20}
                      selectedId={homeOrBusinessSelection.toString()}
                      onClick={() => setHomeOrBusinessSelection(20)}
                      key={"home-or-biz-selection-home"}
                    >
                      <HomeDeliveryIcon />
                      <span>My Home</span>
                    </WBMSelectionCard>
                    <WBMSelectionCard
                      id={"home-or-biz-selection-biz"}
                      selected={homeOrBusinessSelection === 10}
                      selectedId={homeOrBusinessSelection.toString()}
                      onClick={() => setHomeOrBusinessSelection(10)}
                      key={"home-or-biz-selection-biz"}
                    >
                      <BusinessDeliveryIcon />
                      <span>My Business/Organization</span>
                    </WBMSelectionCard>
                    <WBMSelectionCard
                      id={"home-or-biz-selection-existingbiz"}
                      selected={homeOrBusinessSelection === 0}
                      selectedId={homeOrBusinessSelection.toString()}
                      onClick={() => setHomeOrBusinessSelection(0)}
                      key={"home-or-biz-selection-existingbiz"}
                    >
                      <span>
                        My Business/Organization is an Existing Customer
                      </span>
                    </WBMSelectionCard>

                    <div className="text-danger line-height-normal">
                      {invalidHomeOrBusinessFeedback}
                    </div>
                  </div>
                </React.Fragment>
              )}
            </div>
            {showZipCodeSection && (
              <div className="select-done">
                <Button
                  type="button"
                  className="btn-primary"
                  onClick={submitNewZipCodeInfo}
                >
                  {showSpinner && (
                    <span
                      className="spinner spinner-border"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  {!showSpinner && <span>DONE</span>}
                </Button>
              </div>
            )}
          </SlideInSelection>
        </div>
      }
    </>
  );
}

export default InsufficientAuthAddressSelect;
